import { useState } from 'react';
import type React from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subStatus, setSubStatus] = useState<
    'idle' | 'sending' | 'success' | 'error'
  >('idle');

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;

    setSubStatus('sending');
    const data = new URLSearchParams();
    data.append('email', email);

    try {
      const response = await fetch(
        'https://readdy.ai/api/form/d6ajcplbiueuoqm1shq0',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: data.toString(),
        }
      );

      if (response.ok) {
        setSubStatus('success');
        setEmail('');
      } else {
        setSubStatus('error');
      }
    } catch (error) {
      console.error('Subscription error:', error);
      setSubStatus('error');
    }
  };

  return (
    <footer className="bg-[#F5F0E6] pt-20 pb-8">
      <div className="max-w-6xl mx-auto px-6 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 mb-16">
          <div>
            <div className="text-[13px] font-bold tracking-[0.2em] uppercase text-[#2C3E50] mb-3">
              Brand Guardian
            </div>
            <p className="text-[#2C3E50]/55 text-[14px] leading-[1.7] mb-6 max-w-xs">
              Norwegian-owned factory visits and brand protection for Western
              brands manufacturing in China.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://cn.linkedin.com/in/lisa-lopez-a772983b5"
                className="w-9 h-9 bg-[#2C3E50] rounded-full flex items-center justify-center text-white hover:bg-[#D98C74] transition-colors cursor-pointer"
                aria-label="LinkedIn"
                rel="nofollow"
                target="_blank"
              >
                <i className="ri-linkedin-fill text-sm"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 bg-[#2C3E50] rounded-full flex items-center justify-center text-white hover:bg-[#D98C74] transition-colors cursor-pointer"
                aria-label="Instagram"
                rel="nofollow"
              >
                <i className="ri-instagram-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-[12px] font-semibold tracking-[0.15em] uppercase text-[#2C3E50]/40 mb-5">
              <a href="#" className="cursor-pointer">
                Quick Links
              </a>
            </h4>
            <div className="space-y-3">
              {['#problem', '#process', '#why', '#pricing', '#contact'].map((href, i) => (
                <a
                  key={href}
                  href={href}
                  className="block text-[14px] text-[#2C3E50]/65 hover:text-[#D98C74] transition-colors cursor-pointer"
                >
                  {['The Problem', 'How It Works', 'Why Lisa', 'Pricing', 'Contact'][i]}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-[12px] font-semibold tracking-[0.15em] uppercase text-[#2C3E50]/40 mb-5">
              <a href="#" className="cursor-pointer">
                Supply Chain Insights
              </a>
            </h4>
            <p className="text-[#2C3E50]/55 text-[13px] leading-[1.6] mb-4">
              Get monthly insights on factory transparency, quality control, and
              brand protection in China.
            </p>

            {subStatus === 'success' ? (
              <p className="text-[#8A9A5B] text-[13px] font-medium">
                Subscribed! Check your inbox.
              </p>
            ) : (
              <form
                className="flex gap-2"
                data-readdy-form
                id="brand-guardian-newsletter"
                onSubmit={handleSubscribe}
              >
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  required
                  className="flex-1 px-4 py-3 border border-[#D98C74]/25 rounded-md text-[13px] text-[#2C3E50] focus:outline-none focus:border-[#D98C74] transition-colors bg-white"
                />
                <button
                  type="submit"
                  disabled={subStatus === 'sending'}
                  className="bg-[#D98C74] text-white px-5 py-3 rounded-md text-[13px] font-semibold hover:bg-[#c47a62] transition-all whitespace-nowrap cursor-pointer disabled:opacity-50"
                >
                  {subStatus === 'sending' ? (
                    <i className="ri-loader-4-line animate-spin"></i>
                  ) : (
                    'Subscribe'
                  )}
                </button>
              </form>
            )}

            {subStatus === 'error' && (
              <p className="text-red-500 text-[12px] mt-2">
                Something went wrong. Try again.
              </p>
            )}
          </div>
        </div>

        <div className="pt-8 border-t border-[#D98C74]/20 flex flex-col md:flex-row items-center justify-between gap-4 text-[12px] text-[#2C3E50]/40">
          <div>&copy; 2025 Brand Guardian. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
}
